import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const AdminIndexRedirect = () => {
  const { user } = useAuth();
  if (!user) return null; // or a loading spinner
  if (user.role === 'superadmin') {
    return <Navigate to="/admin/dashboard" replace />;
  }
  return <Navigate to="/admin/orders" replace />;
};

export default AdminIndexRedirect; 